var $class="se2--checkbox",$name="checkbox",$path="app/partials/checkbox/index.js",$this={$class,$name,$path,};import shell from 'app/modules/shell';
import { toggleInvalid } from 'app/partials/input';

import checkCheckboxValidity from 'app/components/utilities/checkCheckboxValidity';

const onChange = ({ target }) => {
  if (!target.closest('.checkbox-container').dataset.required) return;
  toggleInvalid(target, !target.checkValidity());
  checkCheckboxValidity(target.closest('.checkbox-container'));
};

const onKeyDown = ({ target }) => {
  toggleInvalid(target, false);
};

export default shell.registerComponent($this, ({ addEventListener, mount }) => {
  mount((element) => {
    addEventListener(element, 'change', onChange);
    addEventListener(element, 'keydown', onKeyDown);
  });
});
